// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty--3EXsv","video":"video--2qiE3"};